type Segment = {
  value: number
  bg: string
  label: string
}

export const Meter = (
  { segments, height = 'h-2' }: { segments: Segment[]; height?: string },
) => {
  const total = segments.reduce((sum, segment) => sum + segment.value, 0)

  return (
    <div
      class={`flex w-full overflow-hidden rounded-selector bg-base-300 ${height}`}
    >
      {total > 0 && segments.map(({ value, bg, label }) =>
        value > 0 && (
          <div
            key={label}
            class={bg}
            style={{ width: `${(value / total) * 100}%` }}
            title={`${label}: ${value}`}
          />
        )
      )}
    </div>
  )
}

export const MeterLegend = (
  { segments, layout = 'flex flex-wrap items-center gap-x-4 gap-y-1' }: {
    segments: Segment[]
    layout?: string
  },
) => (
  <div class={layout}>
    {segments.map(({ value, bg, label }) => (
      <span
        key={label}
        class='flex flex-wrap justify-center items-center gap-x-1.5'
      >
        <span class={`size-2 shrink-0 rounded-selector ${bg}`} />
        <span class='text-sm font-bold'>{value}</span>
        <span class='text-base-content/60 text-xs font-semibold uppercase tracking-wider'>
          {label}
        </span>
      </span>
    ))}
  </div>
)

const DONUT_SIZE = { '--size': '7rem', '--thickness': '0.75rem' }

// daisyUI paints only the filled arc, so the empty track is a second ring
// stacked underneath, and the arc is skipped entirely at 0 — otherwise its
// rounded end cap shows up as a stray dot on an empty ring.
export const Donut = (
  { percent, color }: { percent: number; color: string },
) => (
  <div class='grid' role='progressbar' aria-valuenow={percent}>
    <div
      class='radial-progress text-base-300 col-start-1 row-start-1'
      style={{ ...DONUT_SIZE, '--value': 100 }}
    />
    {percent > 0 && (
      <div
        class={`radial-progress col-start-1 row-start-1 ${color}`}
        // saturates at 100% while the label keeps the real overuse figure
        style={{ ...DONUT_SIZE, '--value': Math.min(percent, 100) }}
      />
    )}
    <span class='col-start-1 row-start-1 place-self-center text-base-content text-2xl font-bold'>
      {percent}%
    </span>
  </div>
)
